// packages
import { h } from 'preact';

// components
import PureComponent from '../components/PureComponent';
import asyncComponent from '../components/AsyncComponent';

// county viewer needs to be an async component, because we want it to render after fetching data
const AsyncCountyViewer = asyncComponent(() =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "CountyViewer" */ '../components/CountyViewer'
  )
);

class StatewideTurnout extends PureComponent {
  constructor() {
    super();
  }

  render() {
    return (
      <div>
        <AsyncCountyViewer county="Total" section="statewide" />
      </div>
    );
  }
}

export default StatewideTurnout;
